import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

// SECTION: AUTH THUNKS

// NOTE: User / Tasker Signin
export const signin = createAsyncThunk("user/login", async (data) => {
  const response = await api.post("user/login", data);
  return response.data;
});

// NOTE: User Signup
export const signup = createAsyncThunk("auth/signup/user", async (data) => {
  const response = await api.post("auth/signup/user", data);
  return response.data;
});

export const requestOTP = createAsyncThunk("user/request-otp", async (data) => {
  const response = await api.post("user/forgot-password", {
    contact: data.emailOrPhone,
  });
  return response.data;
});

export const verifyOTP = createAsyncThunk(
  "user/verify-otp",
  async ({ contact, otp }) => {
    const response = await api.post("user/verify-otp", {
      contact,
      otp,
    });
    return response.data;
  }
);

export const requestLink = createAsyncThunk(
  "admin/request-link",
  async (data) => {
    const response = await api.post("admin/forgot-password", {
      email: data.emailOrPhone,
    });
    return response.data;
  }
);

// validateToken.js
export const validateToken = createAsyncThunk(
  "admin/validate-token",
  async ({ id, token }) => {
    const res = await api.get(`/admin/reset-password/${id}/${token}`);
    return res.data;
  }
);

// updatePassword.js
export const updatePassword = createAsyncThunk(
  "admin/update-password",
  async ({ id, token, data }) => {
    const res = await api.post(`/admin/reset-password/${id}/${token}`, {
      password: data.password,
    });
    return res.data;
  }
);

// NOTE: Tasker Signup
export const taskerSignup = createAsyncThunk(
  "auth/signup/tasker",
  async (data) => {
    const response = await api.post("user/signup/tasker", data);
    return response.data;
  }
);

// NOTE: Authenticated link for resetting password
export const resetPassword = createAsyncThunk(
  "auth/reset/password",
  async (data) => {
    const response = await api.post("auth/forgot-password", data);
    return response.data;
  }
);

// SECTION: USER THUNKS

// NOTE: Edit Client Profile
export const updateUserProfile = createAsyncThunk(
  "auth/update/user/profile",
  async (data) => {
    const response = await api.put("user/profile", data);
    return response.data;
  }
);
